import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import compose from 'lodash/flowRight'
import { translate } from "react-i18next"

import getAppointment from 'graphql/queries/getAppointment'
import createReview from 'graphql/mutations/createReview'
import Loading from 'cogsworth/components/Loading/Loading'
import Checkmark from 'cogsworth/components/Checkmark/Checkmark'

import './ratingPage.css'

class RatingPage extends Component {

  constructor(props) {
    super(props)

    this.state = {
      hoveredStar: null,
      selectedRating: null,
      saving: false,
      saved: false,
      comment: "",
    }

    this.handleStarEnter = this.handleStarEnter.bind(this)
    this.handleStarsLeave = this.handleStarsLeave.bind(this)
    this.onStarClick = this.onStarClick.bind(this)
    this.saveReview = this.saveReview.bind(this)
  }

  handleStarEnter(index) {
    this.setState({
      hoveredStar: index
    })
  }

  handleStarsLeave() {
    this.setState({
      hoveredStar: 0,
    })
  }

  onStarClick(index) {
    this.setState({
      selectedRating: index,
    })
  }

  async saveReview() {
    this.setState({ saving: true })

    try {
      await this.props.mutate({
        variables: {
          appointmentId: this.props.match.params.id,
          token: this.props.match.params.token,
          rating: this.state.selectedRating,
          comment: this.state.comment,
        }
      })

      this.setState({
        saved: true,
        saving: false,
      })
    } catch(error) {
      this.setState({ saving: false })
      alert(error)
    }
  }

  renderStars() {
    const starClassFor = (star) => {
      const stars = this.state.hoveredStar || this.state.selectedRating || 0
      if (star <= stars) {
        return 'fa fa-star'
      }
      return 'fa fa-star-o'
    }

    return (
      <div className="stars" onMouseLeave={this.handleStarsLeave}>
        <div className={starClassFor(1)} onMouseEnter={() => this.handleStarEnter(1)} onClick={() => { this.onStarClick(1) }}></div>
        <div className={starClassFor(2)} onMouseEnter={() => this.handleStarEnter(2)} onClick={() => { this.onStarClick(2) }}></div>
        <div className={starClassFor(3)} onMouseEnter={() => this.handleStarEnter(3)} onClick={() => { this.onStarClick(3) }}></div>
        <div className={starClassFor(4)} onMouseEnter={() => this.handleStarEnter(4)} onClick={() => { this.onStarClick(4) }}></div>
        <div className={starClassFor(5)} onMouseEnter={() => this.handleStarEnter(5)} onClick={() => { this.onStarClick(5) }}></div>
      </div>
    )
  }

  renderThankYou() {
    const message = this.props.data.business.bookingTemplatesHtml["review-thankyou-screen"] || "Thank you! Your review has been submitted."
    return (
      <div className="thankyou">
        <Checkmark color={this.props.data.appointment.business.color} />
        <div dangerouslySetInnerHTML={{ __html: message }}></div>
      </div>
    )
  }

  renderBody() {
    if (this.props.data.loading) {
      return <Loading />
    }

    if (!this.props.data.business.availableFeatures.bookingReviews) {
      return (
        <div className="thankyou">
          Booking reviews are not available for this business.
        </div>
      )
    }

    const { appointment } = this.props.data

    if (this.state.saved || appointment.reviews.length > 0) {
      return this.renderThankYou()
    }

    return (
      <div>
        <h4>{ appointment.service.name }</h4>
        <small>provided by { appointment.staff.name }</small>
        <hr />
        <div className="customer">
          <p>Please rate your experience with { appointment.business.name }.</p>
        </div>
        {
          this.renderStars()
        }
        <textarea name="" id="" cols="30" rows="4" placeholder="Share details of your experience" value={this.state.comment} onChange={(e) => { this.setState({ comment: e.target.value }) }}></textarea>
        <div className="actions">
          <button className="btn btn-primary" onClick={this.saveReview} disabled={this.state.selectedRating === null || this.state.saving} >
            <i className={ this.state.saving ? 'fa fa-gear fa-spin' : 'fa fa-check' }></i>&nbsp;&nbsp;Send Review
          </button>
        </div>
      </div>
    )
  }

  render() {
    if (this.props.data.loading) {
      return <Loading />
    }

    return (
      <div className="rating-page">
        <div className="content">
          { this.renderBody() }
        </div>
      </div>
    )
  }
}

export default (compose(
  graphql(getAppointment,
    {
      options: (props) => ({
        variables: {
          id: props.match.params.id,
          token: props.match.params.token,
        }
      })
    }
  ),
  graphql(createReview)
)(translate("translations")(RatingPage)))
